import React, { useState, useEffect } from "react"
import classnames from "classnames"
import { Row, Col } from "react-bootstrap"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import { useCollectionAction } from "../../actions/useCollectionAction"
import { GalleryHeader } from "../../components/GalleryHeader"
import Container from "../../components/Layout/Container"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import MobileMenu from "../../components/Layout/MobileMenu"
import { SearchSortHeader } from "../../components/Layout/SearchSortHeader"
import Wrapper from "../../components/Layout/Wrapper"
import LeftSide from "../../components/LeftSide"
import { Loader } from "../../components/Layout/Loader"
import { Masonry } from "../../components/Masonry"
import { ApplyButton } from "./ApplyButton"
import { FilterButton } from "./FilterButton"
import styles from "./CollectionPage.module.scss"
import { SeoTags } from "../../components/Layout/SeoTags"
import { useContactAction } from "../../actions/useContactAction"
import { GalleryContactModal } from "../../components/GalleryContactModal"
import { getArtworkSize } from "../../../services/utils/getArtworkSize"

const Collection = ({ catalog, gallery, filters, collection }) => {
  // Use collection label if provided, else re convert to regular and capitalize first letter of each word
  const collectionTitle =
    catalog.collection_label?.label ??
    decodeURIComponent(collection)
      .trim()
      .split(" ")
      .filter((w) => w.length > 0)
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(" ")
  const [catalogData, setCatalogData] = useState(catalog)
  const {
    loading,
    search,
    collapses,
    clearFilters,
    onClickItem,
    toggleExpand,
    totalFilters,
    showFilters,
    setShowFilters,
    sort,
    setSort,
    sorts,
  } = useCollectionAction({
    catalogData,
    setCatalogData,
    gallery,
    filters,
    collection,
  })

  const {
    form,
    setForm,
    onSubmit,
    handleShow,
    handleClose,
    modal,
    success,
    error,
    errorMessage,
    onReCAPTCHAChange,
    recaptchaRef,
    loadingContact,
  } = useContactAction(gallery)

  const LoadedElements = () => {
    if (loading) return <Loader />

    const items = catalogData.data.map((item) => ({
      to: linksBuilder.artworks(item.id, item.title),
      href: "/artworks/[id]",
      title: item.title,
      image: item.image,
      subtitle: item.artistname,
      subSubTitle: getArtworkSize(item.width, item.height),
      sold: item.sold,
      price: item.price ? gallery?.currency?.symbol + item.price : null,
      textAlign: "left",
    }))

    return <Masonry id="artworks" items={items} />
  }

  const seoURL = `https://discover.artplacer.com/${linksBuilder.collections(
    gallery.domain,
    collection,
  )}`

  return (
    <>
      <SeoTags
        title={`Collection | ${collectionTitle} | Discover ArtPlacer`}
        description="Discover fine art paintings, posters, prints and photographs from the comfort of your home."
        url={seoURL}
        canonical={seoURL}
      />
      <HelmetTitle title={`Collection | ${collectionTitle}`} />
      <Wrapper>
        <Container>
          <GalleryHeader galleryDetails={gallery} onClickContact={handleShow} />
          <Row>
            <Col xs={12}>
              <h2
                className="text-capitalize"
                style={{
                  marginTop: "30px",
                  fontSize: "20px",
                  whiteSpace: "pre",
                }}>
                collection: {collectionTitle}
              </h2>
            </Col>
          </Row>
          <Row className="py-4">
            <Col xs={12} sm={12} md={2} className="d-none d-md-block">
              <LeftSide
                search={search}
                collapses={collapses}
                clearFilters={clearFilters}
                onClickItem={onClickItem}
                toggleExpand={toggleExpand}
                totalFilters={totalFilters}
                filters={filters}
              />
            </Col>
            <Col xs={12} sm={12} md={10}>
              <SearchSortHeader
                hideSearch={true}
                sort={sort}
                setSort={setSort}
                sorts={sorts}>
                <FilterButton onClick={() => setShowFilters(true)} />
              </SearchSortHeader>
              <LoadedElements />
            </Col>
          </Row>

          <GalleryContactModal
            form={form}
            setForm={setForm}
            galleryDetails={gallery}
            modal={modal}
            onSubmit={onSubmit}
            handleClose={handleClose}
            error={error}
            errorMessage={errorMessage}
            recaptchaRef={recaptchaRef}
            onReCAPTCHAChange={onReCAPTCHAChange}
          />
        </Container>
      </Wrapper>
      {showFilters && (
        <MobileMenu className={styles["mobile-menu-container"]}>
          <div
            className={classnames(
              styles["filter-mobile"],
              "position-relative",
            )}>
            <LeftSide
              search={search}
              collapses={collapses}
              clearFilters={clearFilters}
              onClickItem={onClickItem}
              toggleExpand={toggleExpand}
              totalFilters={totalFilters}
              filters={filters}
            />
            <ApplyButton onClick={() => setShowFilters(false)} />
          </div>
        </MobileMenu>
      )}
    </>
  )
}

export default Collection
